import { CountriesEnum } from '@shared/components/country/models/country-country.model';

// ENUMS #######################################################################
export enum ContinentsEnum {
	AFRICA = 'africa',
	AMERICAS = 'americas',
	ASIA = 'asia',
	EUROPE = 'europe',
	OCEANIA = 'oceania',
}


// INTERFACES ##################################################################


// TYPES #######################################################################
export type Continents = ReadonlyMap<ContinentsEnum, Continent>;
export type Continent = ReadonlySet<CountriesEnum>;
export type ContinentI18n = {
	[ key in ContinentsEnum ]?: string;
};


// CONSTANTS ###################################################################
/** `Set` containing all African countries and territories of interest */
export const AFRICA: Continent = new Set<CountriesEnum>( [
	CountriesEnum.ALGERIA,
	CountriesEnum.ANGOLA,
	CountriesEnum.BENIN,
	CountriesEnum.BOTSWANA,
	CountriesEnum.BURKINA_FASO,
	CountriesEnum.BURUNDI,
	CountriesEnum.CABO_VERDE,
	CountriesEnum.CAMEROON,
	CountriesEnum.CENTRAL_AFRICAN_REPUBLIC,
	CountriesEnum.CHAD,
	CountriesEnum.COMOROS,
	CountriesEnum.CONGO_DEMOCRATIC_REPUBLIC,
	CountriesEnum.CONGO,
	CountriesEnum.COTE_DIVOIRE,
	CountriesEnum.DJIBOUTI,
	CountriesEnum.EGYPT,
	CountriesEnum.EQUATORIAL_GUINEA,
	CountriesEnum.ERITREA,
	CountriesEnum.ESWATINI,
	CountriesEnum.ETHIOPIA,
	CountriesEnum.GABON,
	CountriesEnum.GAMBIA,
	CountriesEnum.GHANA,
	CountriesEnum.GUINEA,
	CountriesEnum.GUINEABISSAU,
	CountriesEnum.KENYA,
	CountriesEnum.LESOTHO,
	CountriesEnum.LIBERIA,
	CountriesEnum.LIBYA,
	CountriesEnum.MADAGASCAR,
	CountriesEnum.MALAWI,
	CountriesEnum.MALI,
	CountriesEnum.MAURITANIA,
	CountriesEnum.MAURITIUS,
	CountriesEnum.MAYOTTE,
	CountriesEnum.MOROCCO,
	CountriesEnum.MOZAMBIQUE,
	CountriesEnum.NAMIBIA,
	CountriesEnum.NIGER,
	CountriesEnum.NIGERIA,
	CountriesEnum.RWANDA,
	CountriesEnum.REUNION,
	CountriesEnum.SAINT_HELENA,
	CountriesEnum.SAO_TOME_AND_PRINCIPE,
	CountriesEnum.SENEGAL,
	CountriesEnum.SEYCHELLES,
	CountriesEnum.SIERRA_LEONE,
	CountriesEnum.SOMALIA,
	CountriesEnum.SOUTH_AFRICA,
	CountriesEnum.SOUTH_SUDAN,
	CountriesEnum.SUDAN,
	CountriesEnum.TANZANIA,
	CountriesEnum.TOGO,
	CountriesEnum.TUNISIA,
	CountriesEnum.UGANDA,
	CountriesEnum.WESTERN_SAHARA,
	CountriesEnum.ZAMBIA,
	CountriesEnum.ZIMBABWE,
] );


/** `Set` containing all Asian countries and territories of interest */
export const ASIA: Continent = new Set<CountriesEnum>( [
	CountriesEnum.AFGHANISTAN,
	CountriesEnum.ARMENIA,
	CountriesEnum.AZERBAIJAN,
	CountriesEnum.BAHRAIN,
	CountriesEnum.BANGLADESH,
	CountriesEnum.BHUTAN,
	CountriesEnum.BRUNEI_DARUSSALAM,
	CountriesEnum.CAMBODIA,
	CountriesEnum.CHINA,
	CountriesEnum.GEORGIA,
	CountriesEnum.HONG_KONG,
	CountriesEnum.INDIA,
	CountriesEnum.INDONESIA,
	CountriesEnum.IRAN,
	CountriesEnum.IRAQ,
	CountriesEnum.ISRAEL,
	CountriesEnum.JAPAN,
	CountriesEnum.JORDAN,
	CountriesEnum.KAZAKHSTAN,
	CountriesEnum.KOREA_DEMOCRATIC_PEOPLES_REPUBLIC,
	CountriesEnum.KOREA_REPUBLIC,
	CountriesEnum.KUWAIT,
	CountriesEnum.KYRGYZSTAN,
	CountriesEnum.LAOS,
	CountriesEnum.LEBANON,
	CountriesEnum.MACAO,
	CountriesEnum.MALAYSIA,
	CountriesEnum.MALDIVES,
	CountriesEnum.MONGOLIA,
	CountriesEnum.MYANMAR,
	CountriesEnum.NEPAL,
	CountriesEnum.OMAN,
	CountriesEnum.PAKISTAN,
	CountriesEnum.PALESTINE,
	CountriesEnum.PHILIPPINES,
	CountriesEnum.QATAR,
	CountriesEnum.SAUDI_ARABIA,
	CountriesEnum.SINGAPORE,
	CountriesEnum.SRI_LANKA,
	CountriesEnum.SYRIA,
	CountriesEnum.TAIWAN,
	CountriesEnum.TAJIKISTAN,
	CountriesEnum.THAILAND,
	CountriesEnum.TIMORLESTE,
	CountriesEnum.TURKEY,
	CountriesEnum.TURKMENISTAN,
	CountriesEnum.UNITED_ARAB_EMIRATES,
	CountriesEnum.UZBEKISTAN,
	CountriesEnum.VIET_NAM,
	CountriesEnum.YEMEN,
] );

/** `Set` containing all countries and territories of interest in the Americas */
export const AMERICAS: Continent = new Set<CountriesEnum>( [
	CountriesEnum.ANGUILLA,
	CountriesEnum.ANTIGUA_AND_BARBUDA,
	CountriesEnum.ARGENTINA,
	CountriesEnum.ARUBA,
	CountriesEnum.BAHAMAS,
	CountriesEnum.BARBADOS,
	CountriesEnum.BELIZE,
	CountriesEnum.BERMUDA,
	CountriesEnum.BOLIVIA,
	CountriesEnum.BONAIRE,
	CountriesEnum.BRAZIL,
	CountriesEnum.CANADA,
	CountriesEnum.CAYMAN_ISLANDS,
	CountriesEnum.CHILE,
	CountriesEnum.COLOMBIA,
	CountriesEnum.COSTA_RICA,
	CountriesEnum.CUBA,
	CountriesEnum.CURACAO,
	CountriesEnum.DOMINICA,
	CountriesEnum.DOMINICAN_REPUBLIC,
	CountriesEnum.ECUADOR,
	CountriesEnum.EL_SALVADOR,
	CountriesEnum.FALKLAND_ISLANDS,
	CountriesEnum.FRENCH_GUIANA,
	CountriesEnum.GREENLAND,
	CountriesEnum.GRENADA,
	CountriesEnum.GUADELOUPE,
	CountriesEnum.GUATEMALA,
	CountriesEnum.GUYANA,
	CountriesEnum.HAITI,
	CountriesEnum.HONDURAS,
	CountriesEnum.JAMAICA,
	CountriesEnum.MARTINIQUE,
	CountriesEnum.MEXICO,
	CountriesEnum.MONTSERRAT,
	CountriesEnum.NICARAGUA,
	CountriesEnum.PANAMA,
	CountriesEnum.PARAGUAY,
	CountriesEnum.PERU,
	CountriesEnum.PUERTO_RICO,
	CountriesEnum.SAINT_BARTHELEMY,
	CountriesEnum.SAINT_KITTS_AND_NEVIS,
	CountriesEnum.SAINT_LUCIA,
	CountriesEnum.SAINT_MARTIN_FRENCH_PART,
	CountriesEnum.SAINT_PIERRE_AND_MIQUELON,
	CountriesEnum.SAINT_VINCENT,
	CountriesEnum.SINT_MAARTEN_DUTCH_PART,
	CountriesEnum.SURINAME,
	CountriesEnum.TRINIDAD_AND_TOBAGO,
	CountriesEnum.TURKS_AND_CAICOS_ISLANDS,
	CountriesEnum.USA,
	CountriesEnum.URUGUAY,
	CountriesEnum.VENEZUELA,
	CountriesEnum.VIRGIN_ISLANDS_BRITISH,
	CountriesEnum.VIRGIN_ISLANDS_US,
] );

/** `Set` containing all European countries and territories of interest */
export const EUROPE: Continent = new Set<CountriesEnum>( [
	CountriesEnum.ALAND_ISLANDS,
	CountriesEnum.ALBANIA,
	CountriesEnum.ANDORRA,
	CountriesEnum.AUSTRIA,
	CountriesEnum.BELARUS,
	CountriesEnum.BELGIUM,
	CountriesEnum.BOSNIA_AND_HERZEGOVINA,
	CountriesEnum.BULGARIA,
	CountriesEnum.CROATIA,
	CountriesEnum.CYPRUS,
	CountriesEnum.CZECHIA,
	CountriesEnum.DENMARK,
	CountriesEnum.ESTONIA,
	CountriesEnum.FAROE_ISLANDS,
	CountriesEnum.FINLAND,
	CountriesEnum.FRANCE,
	CountriesEnum.GERMANY,
	CountriesEnum.GIBRALTAR,
	CountriesEnum.GREECE,
	CountriesEnum.GUERNSEY,
	CountriesEnum.HOLY_SEE,
	CountriesEnum.HUNGARY,
	CountriesEnum.ICELAND,
	CountriesEnum.IRELAND,
	CountriesEnum.ISLE_OF_MAN,
	CountriesEnum.ITALY,
	CountriesEnum.JERSEY,
	CountriesEnum.LATVIA,
	CountriesEnum.LIECHTENSTEIN,
	CountriesEnum.LITHUANIA,
	CountriesEnum.LUXEMBOURG,
	CountriesEnum.MALTA,
	CountriesEnum.MOLDOVA,
	CountriesEnum.MONACO,
	CountriesEnum.MONTENEGRO,
	CountriesEnum.NETHERLANDS,
	CountriesEnum.NORWAY,
	CountriesEnum.POLAND,
	CountriesEnum.PORTUGAL,
	CountriesEnum.NORTH_MACEDONIA,
	CountriesEnum.ROMANIA,
	CountriesEnum.RUSSIAN_FEDERATION,
	CountriesEnum.SAN_MARINO,
	CountriesEnum.SERBIA,
	CountriesEnum.SLOVAKIA,
	CountriesEnum.SLOVENIA,
	CountriesEnum.SPAIN,
	CountriesEnum.SVALBARD_AND_JAN_MAYEN,
	CountriesEnum.SWEDEN,
	CountriesEnum.SWITZERLAND,
	CountriesEnum.UKRAINE,
	CountriesEnum.UNITED_KINGDOM,
] );

/** `Set` containing all countries and territories of interests of Oceania */
export const OCEANIA: Continent = new Set<CountriesEnum>( [
	CountriesEnum.AMERICAN_SAMOA,
	CountriesEnum.ANTARCTICA,
	CountriesEnum.AUSTRALIA,
	CountriesEnum.BOUVET_ISLAND,
	CountriesEnum.BRITISH_INDIAN_OCEAN_TERRITORY,
	CountriesEnum.CHRISTMAS_ISLAND,
	CountriesEnum.COCOS_ISLANDS,
	CountriesEnum.COOK_ISLANDS,
	CountriesEnum.FIJI,
	CountriesEnum.FRENCH_POLYNESIA,
	CountriesEnum.FRENCH_SOUTHERN_TERRITORIES,
	CountriesEnum.GUAM,
	CountriesEnum.HEARD_ISLAND_AND_MCDONALD_ISLANDS,
	CountriesEnum.KIRIBATI,
	CountriesEnum.MARSHALL_ISLANDS,
	CountriesEnum.MICRONESIA,
	CountriesEnum.NAURU,
	CountriesEnum.NEW_CALEDONIA,
	CountriesEnum.NEW_ZEALAND,
	CountriesEnum.NIUE,
	CountriesEnum.NORFOLK_ISLAND,
	CountriesEnum.NORTHERN_MARIANA_ISLANDS,
	CountriesEnum.PALAU,
	CountriesEnum.PAPUA_NEW_GUINEA,
	CountriesEnum.PITCAIRN,
	CountriesEnum.SAMOA,
	CountriesEnum.SOLOMON_ISLANDS,
	CountriesEnum.SOUTH_GEORGIA,
	CountriesEnum.TOKELAU,
	CountriesEnum.TONGA,
	CountriesEnum.TUVALU,
	CountriesEnum.UNITED_STATES_MINOR_OUTLYING_ISLANDS,
	CountriesEnum.VANUATU,
	CountriesEnum.WALLIS_AND_FUTUNA,
] );


/** `Map` with countryIdentifier-by-continent `Set`s */
export const CONTINENTS: Continents = new Map<ContinentsEnum, Continent>( [
	[ ContinentsEnum.AFRICA, AFRICA ],
	[ ContinentsEnum.AMERICAS, AMERICAS ],
	[ ContinentsEnum.ASIA, ASIA ],
	[ ContinentsEnum.EUROPE, EUROPE ],
	[ ContinentsEnum.OCEANIA, OCEANIA ]
] );
